export const ContentManageRoutes = [
  {
    path: '/Admin/ContentManage/NewsManage',
    name: '新闻管理',
    component: () => import('./NewsManage/index.vue'),
    meta: {
      title: '新闻管理'
    }
  }, {
    path: '/Admin/ContentManage/NewsManage/Edit',
    name: '新增新闻',
    component: () => import('./NewsManage/Edit.vue'),
    meta: {
      title: '新增新闻'
    }
  }, {
    path: '/Admin/ContentManage/HistoryManage',
    name: '历史管理',
    component: () => import('./HistoryManage/index.vue'),
    meta: {
      title: '历史管理'
    }
  }, {
    path: '/Admin/ContentManage/HistoryManage/Edit',
    name: '新增历史',
    component: () => import('./HistoryManage/Edit.vue'),
    meta: {
      title: '新增历史 '
    }
  }, {
    path: '/Admin/ContentManage/QAManage',
    name: '问答管理',
    component: () => import('./QAManage/index.vue'),
    meta: {
      title: '问答管理'
    }
  }, {
    path: '/Admin/ContentManage/CommentManage',
    name: '评论管理',
    component: () => import('./CommentManage/index.vue'),
    meta: {
      title: '评论管理'
    }
  }, {
    path: '/Admin/ContentManage/TeacherManage',
    name: '教师管理',
    component: () => import('./TeacherManage/index.vue'),
    meta: {
      title: '教师管理'
    }
  },
  {
    path: '/Admin/ContentManage/TeacherManage/Edit',
    name: '新增教师信息',
    component: () => import('./TeacherManage/Edit.vue'),
    meta: {
      title: '新增教师信息'
    }
  },{
    path: '/Admin/ContentManage/StudentManage',
    name: '内容管理-明日之星',
    component: () => import('./StudentManage/index.vue'),
    meta: {
      title: '明日之星'
    }
  }, {
    path: '/Admin/ContentManage/StudentManage/Edit',
    name: '新增明日之星',
    component: () => import('./StudentManage/Edit.vue'),
    meta: {
      title: '新增明日之星'
    }
  }
]



// WEBPACK FOOTER //
// ./src/pages/Admin/AdminHome/ContentManage/routes.js